import axios from './axios';
import { GetStorageComponent } from './storage';
import { AxiosRequestConfig } from 'axios';

interface AsyncFuncProps extends AxiosRequestConfig{
  'noRetry'?: boolean
}

export const asyncFunc = (request: AsyncFuncProps) => {
  const accessToken = GetStorageComponent('access_token');

  if (accessToken) {
    request.headers = {
      Authorization: 'bearer ' + accessToken
    };
  }

  return axios
    .request(request)
    .then((res: any) => {
      return (res.data) ? [null, res.data] : [res.data, null];
    })
    .catch((err: any) => {
      return err && err.data && err.data.error ? [err.data.error, null] :
        err && err.data && err.data.messagae ? [err.data.message, null] :
          [err, null];
    });
};

export const asyncPromiseFunc = (request: AxiosRequestConfig) => {
  const accessToken = GetStorageComponent('access_token');

  if ( accessToken ) {
    request.headers = {
      Authorization: 'bearer ' + accessToken
    };
  }

  return axios
    .request(request);
}

export const axiosPromiseFunction = <T>(request: AsyncFuncProps): Promise<T> => {
  const accessToken = GetStorageComponent('access_token');
  if (accessToken) {
    request.headers = {
      Authorization: 'bearer ' + accessToken
    }
  }
  
  return new Promise((resolve, reject) => {
    axios
      .request(request)
      .then((res: any) => {
        resolve(res.data)
      })
      .catch((err: any) => {
        const error =  err && err.data && err.data.error ? err.data.error : 
                err && err.data && err.data.messagae ? err.data.message :
                  err;
        reject(error);
      });
  })
}
